import { useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import InputAnimated from './InputAnimated'
import AccountIcon from '../assets/icons/AccountIcon'
import MailIcon from '../assets/icons/MailIcon'
import PhoneIcon from '../assets/icons/PhoneIcon'
import WorkIcon from '../assets/icons/WorkIcon'
import { postIndexForm } from '../api/community'
import SendFormModal from './modals/SendFormModal'

const ContactForm = () => {
  const [showModal, setShowModal] = useState({
    sended: false,
    show: false
  })

  const INTEREST_TYPES = [
    'Espacios compartidos',
    'Salas de reuniones',
    'Oficinas privadas',
    'Eventos sociales',
    'Jornadas laborales',
    'Alianzas estratégicas',
  ]

  const INTEREST_DICTIONARY = {
    'Espacios compartidos': 'Espacio compartido',
    'Salas de reuniones': 'Salas de reuniones',
    'Oficinas privadas': 'Oficinas privadas',
    'Eventos sociales': 'Eventos sociales',
    'Jornadas laborales': 'Jornadas laborales',
    'Alianzas estratégicas': 'Alianzas estratégicas'
  }

  const formik = useFormik({
    initialValues: {
      name: '',
      last_name: '',
      company_name: '',
      email: '',
      phone: '',
      interest: 'Espacios compartidos',
      message: '',
    },
    validateOnChange: false,
    validationSchema: Yup.object({
      name: Yup.string()
        .required('Tu nombre es requerido')
        .max(50, 'Máximo de caracteres: 50'),
      last_name: Yup.string()
        .required('Tu apellido es requerido')
        .max(50, 'Máximo de caracteres: 50'),
      company_name: Yup.string().max(50, 'Máximo de caracteres: 50'),
      email: Yup.string()
        .email('Email no valido')
        .required('Tu email es requerido')
        .max(50, 'Máximo de caracteres: 50'),
      phone: Yup.number().required('El número de teléfono es requerido').typeError('El número de teléfono es inválido'),
      interest: Yup.string()
        .required('Selecciona un tipo de consulta'),
      message: Yup.string().required('El mensaje es requerido')
    }),
    onSubmit: async (data) => {
      if (data.email.includes(' ')) {
        data.email = data.email.replace(/ /g, '')
      }

      const dataWithInterest = {
        ...data,
        interest: INTEREST_DICTIONARY[data.interest]
      }

      const formFiltered = Object.entries(dataWithInterest).reduce(
        (a, [k, v]) => (v ? ((a[k] = v), a) : a),
        {}
      )

      const response = await postIndexForm(formFiltered)
      if (response) {
        toggleShowmodal(true)
        formik.resetForm()
      } else {
        toggleShowmodal(false)
      }
    }
  })

  const toggleShowmodal = (sended) => {
    setShowModal({
      sended: sended,
      show: true
    })
  }

  const closeShowmodal = () => {
    setShowModal({
      sended: false,
      show: false
    })
  }

  return (
    <>
      <section className="ContactForm__Container container-fluid position-relative">
        <form className="ContactForm container-custom" onSubmit={formik.handleSubmit}>
          <span className="caption text-green">Enviá tu consulta</span>

          <div className="ContactForm__Inputs">
            <InputAnimated
              label="Nombre*"
              name="name"
              type="text"
              value={formik.values.name}
              onChange={formik.handleChange}
              error={formik.errors.name}
              icon={<AccountIcon width={24} height={24} className='text-green'/>}
            />

            <InputAnimated
              label="Apellido*"
              name="last_name"
              type="text"
              value={formik.values.last_name}
              onChange={formik.handleChange}
              error={formik.errors.last_name}
              icon={<AccountIcon width={24} height={24} className='text-green'/>}
            />

            <InputAnimated
              label="Email/correo electrónico*"
              name="email"
              type="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              error={formik.errors.email}
              icon={<MailIcon width={24} height={24} className='text-green'/>}
            />

            <InputAnimated
              label="Número telefónico*"
              name="phone"
              type="tel"
              value={formik.values.phone}
              onChange={formik.handleChange}
              error={formik.errors.phone}
              icon={<PhoneIcon width={24} height={24} className='text-green'/>}
            />

            <InputAnimated
              label="Nombre de tu empresa o marca"
              name="company_name"
              type="text"
              value={formik.values.company_name}
              onChange={formik.handleChange}
              error={formik.errors.company_name}
              icon={<WorkIcon width={24} height={24} className='text-green'/>}
            />
          </div>

          <div className="ContactForm__Inputs2">
            <div className='d-flex flex-column gap-2 w-full align-items-start'>
              <label className='text-black text-4'>Quiero saber sobre:</label>
              <InputAnimated
                withoutLabel
                className='custom-select'
                name="interest"
                label='Quiero saber sobre:'
                angleColor='#1E1E1E'
                type="select"
                value={formik.values.interest}
                list={INTEREST_TYPES}
                onChange={formik.setFieldValue}
                error={formik.errors.interest}
                icon={<WorkIcon width={24} height={24} className='text-green'/>}
              />
            </div>

            <div className='d-flex flex-column w-100 position-relative'>
              <textarea
                className="ContactForm__Textarea"
                name="message"
                id="message"
                cols="30"
                rows="5"
                placeholder="Escribe aquí tu consulta"
                value={formik.values.message}
                onChange={(e) => formik.setFieldValue('message', e.target.value)}
              />
              {formik.errors.message && (
                <span className="Input__Error">
                  {formik.errors.message}
                </span>
              )}
            </div>
          </div>

          <button
            className="ContactForm__Button button-new-orange"
            type="submit"
            onClick={formik.handleSubmit}
          >
            Enviar
          </button>
        </form>
        {showModal.show && (
          <SendFormModal
            closeModal={closeShowmodal}
            sended={showModal.sended}
          />
        )}
      </section>
    </>
  )
}

export default ContactForm